export function applyAspect(definition) {
    return function (target) {
        var ctor = definition["constructor"] instanceof Array ? definition["constructor"] : [];
        delete definition["constructor"];
        var _loop_1 = function (key) {
            definition[key].forEach(function (advice) {
                return Object.defineProperty(target.prototype, key, advice(target, key, Object.getOwnPropertyDescriptor(target.prototype, key)));
            });
        };
        for (var key in definition) {
            _loop_1(key);
        }
        ctor.forEach(function (advice) { return target = advice(target); });
        return target;
    };
}
//# sourceMappingURL=apply-aspect.js.map